import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { LocalStorageTeenus } from './local-storage-teenus';
import { onAuthStorageKey } from './auth-teenus';
import router from '@/router'

const _localStorageTeenus = new LocalStorageTeenus();

axios.interceptors.response.use(
    function (response) {
        return response
    },

    function (error) {
        if (error.code === "ERR_NETWORK" || (error.response && error.response.status === 401)) {
            if (_localStorageTeenus.anna(onAuthStorageKey) === 'true') {
                _localStorageTeenus.kustuta(onAuthStorageKey);
                router.push({ name: 'SessioonAegunudLeht' });
            }
            else {
                router.push({ name: 'MaandumisLeht' });
            }
        }
        return Promise.reject(error)
    }
)

export class AxiosTeenus {

    public async get<T>(url: string, config?: AxiosRequestConfig<any>): Promise<AxiosResponse<T>> {
        return await axios.get(url, config);
    }

    public async post<T>(url: string, data?: any, config?: AxiosRequestConfig<any>): Promise<AxiosResponse<T>> {
        return await axios.post(url, data, config);
    }
}